// src/services/serviceService.js
import axios from 'axios';
import { toFormData } from './utils'; // Utility function

const serviceService = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

export const getServices = (serviceData) => {
    const formData = toFormData(serviceData);
    return serviceService.post('/services', formData);
};

export const getServiceDetails = (slug) => {
    return serviceService.get('/services/' + slug);
};

export default serviceService;
